import { DEFAULT_LIST_SIZE as e } from "../../temp-lib/constants/layout.js";
const a = {
  hasNextPage: !1,
  hasPreviousPage: !1,
  total: 0,
  totalPage: 0,
  page: 1,
  pageSize: e,
  previousCursor: void 0,
  nextCursor: void 0
};
export {
  a as DEFAULT_PAGE_INFO
};
//# sourceMappingURL=paging.js.map
